import React, { Component } from "react";
import PropTypes from "prop-types";

import supportsWebMAlpha from "../components/supports/webmAlpha";

export default class SuitPlayer extends Component {
  static propTypes = {
    videoSrc: PropTypes.array.isRequired,
    posterSrc: PropTypes.string
  };

  async componentDidMount() {
    const isIOSsafari = /iP(ad|od|hone)/i.test(window.navigator.userAgent) && /WebKit/i.test(window.navigator.userAgent) && !(/(CriOS|FxiOS|OPiOS|mercury)/i.test(window.navigator.userAgent));
    console.log('test webm alpha')
    const supportsWebMAlphaResult = await supportsWebMAlpha()
    console.log('result', supportsWebMAlphaResult);
    this.setState({ isIOSsafari, supportsWebMAlphaResult  } );
  }

  videoRef = React.createRef();
  interval = null;

  state = {
    ready: false,
    isIOSsafari: true
  };

  attachVideoPlayer = ref => {
    this.videoRef = ref;
  };

  onCanPlayThrough = () => {
    this.setState({ ready: true });
  };




  render() {
    const { videoSrc, suitName, posterSrc } = this.props;
    const { isIOSsafari, supportsWebMAlphaResult } = this.state;

    return (

      (supportsWebMAlphaResult !== undefined ) && (
      <div
        className="suitPlayer"
        onMouseOut={() => this.videoRef.pause()}
        onMouseEnter={() => this.videoRef.play()}
      >
        <video
          ref={this.attachVideoPlayer}
          onCanPlayThrough={ this.onCanPlayThrough }
          poster={ posterSrc }
          preload={true.toString()}
          loop
          muted={ true }
          controls={ isIOSsafari }
        >
          { supportsWebMAlphaResult && <source src={videoSrc[0].src} type={videoSrc[0].type} />}
          <source src={videoSrc[1].src} type={videoSrc[1].type} />
        </video>
        <h4 className="text-center">{suitName}</h4>
      </div>)
    );
  }
}


/*          
disableremoteplayback="true" from video tag

{
            videoSrc.map((v, i) => {
              if (v.type === "video/webm" && supportsWebMAlphaResult )
                return <source key={i} src={v.src} type={v.type} />
              else if (v.type !== "video/webm")
                return <source key={i} src={v.src} type={v.type} />
            })}
*/
